document.addEventListener("DOMContentLoaded", function () {
    // Hole den Wert des Metafelds aus dem <p> Tag
    var metaHerstellerElement = document.querySelector('.product-details__extra-second p');
    var metaHersteller = metaHerstellerElement ? metaHerstellerElement.textContent.trim().toLowerCase() : null;

    // Objekt mit den Herstellerinformationen
    var herstellerInfos = {
        "pokemon": `
            <div class="hersteller-info">
                <div class="hersteller-header">
                    <h3 class="hersteller-title">Angaben zum Hersteller</h3>
                </div>
                <table class="hersteller-table">
                    <tbody>
                        <tr><td class="hersteller-label">Firmenname</td><td class="hersteller-value">The Pokemon Company International Ireland Limited</td></tr>
                        <tr><td class="hersteller-label">Adresse</td><td class="hersteller-value">3rd Floor, 2 Central Plaza, Dame Street NE Suite 1600<br>Dublin, Irland, D02 T0X4</td></tr>
                        <tr><td class="hersteller-label">Support</td><td class="hersteller-value"><a href="https://support.pokemon.com/" target="_blank">https://support.pokemon.com/</a></td></tr>
                    </tbody>
                </table>
            </div>
        `,
        "lorcana": `
            <div class="hersteller-info">
                <div class="hersteller-header">
                    <h3 class="hersteller-title">Angaben zum Hersteller</h3>
                </div>
                <table class="hersteller-table">
                    <tbody>
                        <tr><td class="hersteller-label">Firmenname</td><td class="hersteller-value">Ravensburger AG</td></tr>
                        <tr><td class="hersteller-label">Adresse</td><td class="hersteller-value">Robert-Bosch-Str. 1<br>Baden-Württemberg<br>Ravensburg, Deutschland, 88214</td></tr>
                        <tr><td class="hersteller-label">E-Mail</td><td class="hersteller-value"><a href="mailto:service@ravensburger.de">service@ravensburger.de</a></td></tr>
                    </tbody>
                </table>
            </div>
        `,
        "magic": `
            <div class="hersteller-info">
                <div class="hersteller-header">
                    <h3 class="hersteller-title">Angaben zum Hersteller</h3>
                </div>
                <table class="hersteller-table">
                    <tbody>
                        <tr><td class="hersteller-label">Firmenname</td><td class="hersteller-value">HASBRO DEUTSCHLAND GmbH</td></tr>
                        <tr><td class="hersteller-label">Adresse</td><td class="hersteller-value">Frankfurter Straße 233<br>Hessen<br>Neu-Isenburg, Deutschland, 63263</td></tr>
                        <tr><td class="hersteller-label">E-Mail</td><td class="hersteller-value"><a href="mailto:zentrale@hasbro.de">zentrale@hasbro.de</a></td></tr>
                    </tbody>
                </table>
            </div>
        `,
        "onepiece": `
            <div class="hersteller-info">
                <div class="hersteller-header">
                    <h3 class="hersteller-title">Angaben zum Hersteller</h3>
                </div>
                <table class="hersteller-table">
                    <tbody>
                        <tr><td class="hersteller-label">Firmenname</td><td class="hersteller-value">BANDAI NAMCO Entertainment Germany GmbH</td></tr>
                        <tr><td class="hersteller-label">Adresse</td><td class="hersteller-value">Carl-Benz-Str. 21<br>Hessen<br>Frankfurt, Deutschland, 60386</td></tr>
                        <tr><td class="hersteller-label">Support</td><td class="hersteller-value"><a href="https://www.bandainamcoent.com/support" target="_blank">https://www.bandainamcoent.com/support</a></td></tr>
                    </tbody>
                </table>
            </div>
        `,
        "dragonball": `
            <div class="hersteller-info">
                <div class="hersteller-header">
                    <h3 class="hersteller-title">Angaben zum Hersteller</h3>
                </div>
                <table class="hersteller-table">
                    <tbody>
                        <tr><td class="hersteller-label">Firmenname</td><td class="hersteller-value">BANDAI NAMCO Entertainment Germany GmbH</td></tr>
                        <tr><td class="hersteller-label">Adresse</td><td class="hersteller-value">Carl-Benz-Str. 21<br>Hessen<br>Frankfurt, Deutschland, 60386</td></tr>
                        <tr><td class="hersteller-label">Support</td><td class="hersteller-value"><a href="https://www.bandainamcoent.com/support" target="_blank">https://www.bandainamcoent.com/support</a></td></tr>
                    </tbody>
                </table>
            </div>
        `,
        "hasbro": `
            <div class="hersteller-info">
                <div class="hersteller-header">
                    <h3 class="hersteller-title">Angaben zum Hersteller</h3>
                </div>
                <table class="hersteller-table">
                    <tbody>
                        <tr><td class="hersteller-label">Firmenname</td><td class="hersteller-value">HASBRO DEUTSCHLAND GmbH</td></tr>
                        <tr><td class="hersteller-label">Adresse</td><td class="hersteller-value">Frankfurter Straße 233<br>Hessen<br>Neu-Isenburg, Deutschland, 63263</td></tr>
                        <tr><td class="hersteller-label">E-Mail</td><td class="hersteller-value"><a href="mailto:zentrale@hasbro.de">zentrale@hasbro.de</a></td></tr>
                    </tbody>
                </table>
            </div>
        `,
        "funko": `
            <div class="hersteller-info">
                <div class="hersteller-header">
                    <h3 class="hersteller-title">Angaben zum Hersteller</h3>
                </div>
                <table class="hersteller-table">
                    <tbody>
                        <tr><td class="hersteller-label">Firmenname</td><td class="hersteller-value">Funko Games</td></tr>
                        <tr><td class="hersteller-label">Adresse</td><td class="hersteller-value">Holborn Viaduct 21<br>London, Vereinigtes Königreich, 4103</td></tr>
                        <tr><td class="hersteller-label">Support</td><td class="hersteller-value"><a href="https://funko.com/contact-us" target="_blank">https://funko.com/contact-us</a></td></tr>
                    </tbody>
                </table>
            </div>
        `,
        "yugioh": `
            <div class="hersteller-info">
                <div class="hersteller-header">
                    <h3 class="hersteller-title">Angaben zum Hersteller</h3>
                </div>
                <table class="hersteller-table">
                    <tbody>
                        <tr><td class="hersteller-label">Firmenname</td><td class="hersteller-value">Konami Digital Entertainment B.V. Germany</td></tr>
                        <tr><td class="hersteller-label">Adresse</td><td class="hersteller-value">Kölner Straße 12<br>Hessen<br>Eschborn, Deutschland, 65760</td></tr>
                        <tr><td class="hersteller-label">Support</td><td class="hersteller-value"><a href="https://www.konami.com/en/eu/support" target="_blank">https://www.konami.com/en/eu/support</a></td></tr>
                    </tbody>
                </table>
            </div>
        `,
        "schleich": `
            <div class="hersteller-info">
                <div class="hersteller-header">
                    <h3 class="hersteller-title">Angaben zum Hersteller</h3>
                </div>
                <table class="hersteller-table">
                    <tbody>
                        <tr><td class="hersteller-label">Firmenname</td><td class="hersteller-value">Schleich GmbH</td></tr>
                        <tr><td class="hersteller-label">Adresse</td><td class="hersteller-value">St. Martin Straße 102<br>81669 München</td></tr>
                        <tr><td class="hersteller-label">E-Mail</td><td class="hersteller-value"><a href="mailto:de.shop@schleich-s.com">de.shop@schleich-s.com</a></td></tr>
                    </tbody>
                </table>
            </div>
        `,
        "mattel": `
            <div class="hersteller-info">
                <div class="hersteller-header">
                    <h3 class="hersteller-title">Angaben zum Hersteller</h3>
                </div>
                <table class="hersteller-table">
                    <tbody>
                        <tr><td class="hersteller-label">Firmenname</td><td class="hersteller-value">Mattel Inc.</td></tr>
                        <tr><td class="hersteller-label">Adresse</td><td class="hersteller-value">333 Continental Boulevard<br>El Segundo, CA 90245, USA</td></tr>
                        <tr><td class="hersteller-label">E-Mail</td><td class="hersteller-value"><a href="mailto:service@mattel.com">service@mattel.com</a></td></tr>
                    </tbody>
                </table>
            </div>
        `,
        "ultrapro": `
            <div class="hersteller-info">
                <div class="hersteller-header">
                    <h3 class="hersteller-title">Angaben zum Hersteller</h3>
                </div>
                <table class="hersteller-table">
                    <tbody>
                        <tr><td class="hersteller-label">Firmenname</td><td class="hersteller-value">Ultra PRO International LLC</td></tr>
                        <tr><td class="hersteller-label">Adresse</td><td class="hersteller-value">6049 E. Slauson Ave<br>Commerce, CA 90040, USA</td></tr>
                        <tr><td class="hersteller-label">E-Mail</td><td class="hersteller-value"><a href="mailto:ulpro@ultrapro.com">ulpro@ultrapro.com</a></td></tr>
                    </tbody>
                </table>
            </div>
        `,
        "nintendo": `
            <div class="hersteller-info">
                <div class="hersteller-header">
                    <h3 class="hersteller-title">Angaben zum Hersteller</h3>
                </div>
                <table class="hersteller-table">
                    <tbody>
                        <tr><td class="hersteller-label">Firmenname</td><td class="hersteller-value">Nintendo of Europe GmbH</td></tr>
                        <tr><td class="hersteller-label">Adresse</td><td class="hersteller-value">Friedrichstraße 147<br>10117 Berlin, Deutschland</td></tr>
                        <tr><td class="hersteller-label">Support</td><td class="hersteller-value"><a href="https://www.nintendo.de/Kontakt-zu-Nintendo/Kontakt-zu-Nintendo-62810.html" target="_blank">Nintendo Support Deutschland</a></td></tr>
                    </tbody>
                </table>
            </div>
        `,
        "lego": `
            <div class="hersteller-info">
                <div class="hersteller-header">
                    <h3 class="hersteller-title">Angaben zum Hersteller</h3>
                </div>
                <table class="hersteller-table">
                    <tbody>
                        <tr><td class="hersteller-label">Firmenname</td><td class="hersteller-value">The LEGO Group</td></tr>
                        <tr><td class="hersteller-label">Adresse</td><td class="hersteller-value">Åstvej 1<br>7190 Billund, Dänemark</td></tr>
                        <tr><td class="hersteller-label">Support</td><td class="hersteller-value"><a href="https://www.lego.com/de-de/service" target="_blank">https://www.lego.com/de-de/service</a></td></tr>
                    </tbody>
                </table>
            </div>
        `
    };

    // Füge die Infos in den Tab-Content ein
    var herstellerContainer = document.querySelector('#hersteller-tab-content');
    if (metaHersteller && herstellerInfos[metaHersteller] && herstellerContainer) {
        herstellerContainer.innerHTML = herstellerInfos[metaHersteller];
    }
});